import { ProviderProps, useContext } from 'react';
import createNamedContext from 'utils/createNamedContext';
import { ScenarioType } from '../config';

export interface ConfigContextValue {
  scenarioType: ScenarioType;
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
}

export const ConfigContext = createNamedContext<ConfigContextValue | null>('ConfigContext', null);

export const ConfigContextProvider = (props: ProviderProps<ConfigContextValue>) => {
  return <ConfigContext.Provider {...props} />;
};

export const useConfigContext = () => {
  const value = useContext(ConfigContext);

  if (!value) {
    throw new Error(
      'useConfigContext hook should be used in a context of ConfigContextProvider component',
    );
  }

  return value;
};
